import { useEffect, useState } from "react";
import { api, inr } from "../../lib/api";
import { PageHead, Badge } from "../../components/ui-bits";
import { toast } from "sonner";
import { Briefcase } from "@phosphor-icons/react";

const KEY = { requested: "overdue", quoted: "upcoming", accepted: "completed", declined: "overdue" };

export default function AdminJobRequests() {
  const [reqs, setReqs] = useState([]);
  const [q, setQ] = useState({});
  const load = () => api.get("/admin/job-requests").then((r) => setReqs(r.data));
  useEffect(() => { load(); }, []);

  const sendQuote = async (r) => {
    const d = q[r.id] || {};
    if (!d.amount) { toast.error("Enter a quote amount"); return; }
    await api.post(`/admin/job-requests/${r.id}/quote`, { amount: Number(d.amount), note: d.note || "" });
    toast.success(`Quote sent to ${r.company}`);
    load();
  };

  return (
    <div>
      <PageHead eyebrow="Ad-hoc Work · Outside Package" title="Job Requests" />
      <div className="space-y-4">
        {reqs.map((r, i) => (
          <div key={r.id} data-testid={`jobreq-${i}`} className="card p-5">
            <div className="flex justify-between items-start mb-2 gap-3 flex-wrap">
              <div>
                <p className="font-head font-bold flex items-center gap-2"><Briefcase size={16} className="text-[#002FA7]" /> {r.title}
                  <span className="text-xs bg-black/5 px-2 py-0.5 rounded-sm">{r.category}</span></p>
                <p className="text-xs text-[#888] mt-0.5">{r.company} · {r.client_email}</p>
              </div>
              <Badge status={KEY[r.status] || "upcoming"}>{r.status}</Badge>
            </div>
            {r.description && <p className="text-sm text-[#555] mb-3">{r.description}</p>}
            {r.status === "requested" ? (
              <div className="flex flex-wrap items-end gap-2 border-t border-black/10 pt-3">
                <div><label className="label block mb-1">Quote amount (₹)</label>
                  <input data-testid={`jobreq-amount-${i}`} type="number" value={(q[r.id]?.amount) || ""} onChange={(e) => setQ({ ...q, [r.id]: { ...q[r.id], amount: e.target.value } })}
                    className="border border-black/20 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" /></div>
                <div className="flex-1 min-w-[200px]"><label className="label block mb-1">Note (optional)</label>
                  <input data-testid={`jobreq-note-${i}`} value={(q[r.id]?.note) || ""} onChange={(e) => setQ({ ...q, [r.id]: { ...q[r.id], note: e.target.value } })}
                    className="w-full border border-black/20 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" /></div>
                <button data-testid={`jobreq-quote-${i}`} onClick={() => sendQuote(r)}
                  className="bg-[#002FA7] hover:bg-[#00227A] text-white px-4 py-2 rounded-sm text-sm transition-colors">Send Quote</button>
              </div>
            ) : (
              <p className="text-sm border-t border-black/10 pt-3">Quote: <b className="tnum">{r.quote_amount != null ? inr(r.quote_amount) : "—"}</b>{r.quote_note ? ` · ${r.quote_note}` : ""}</p>
            )}
          </div>
        ))}
        {reqs.length === 0 && <p className="card p-8 text-sm text-[#888] text-center">No job requests yet.</p>}
      </div>
    </div>
  );
}
